<template>
  <div 
    :id="id"
    :aria-checked="value"
    :aria-label="label"
    :class="['switch', { active: type == 'boolean' ? value : value != 1 }]"
    role="switch"
    tabindex="0"
    @click.stop="toggle"
    @keydown.space="toggle"
    @keydown.enter="toggle"
  > 
    <label :for="id">
      {{ label }}
    </label>
    <div 
      v-if="type == 'boolean'"
      class="toggles boolean"
    >
      <div class="toggle">
        <a aria-hidden="true">
          <svg 
            v-if="icon"
            preserveAspectRatio="none"
            :viewBox="icon.viewBox"
          >
            <path 
              :d="icon.d" 
            />
          </svg>
        </a>
      </div>
    </div>
    <div 
      v-else-if="type == 'number'"
      class="toggles number"
    >
      <div 
        class="toggle"
        @click.stop="$emit('toggle', value - 0.1 )"
      >
        <a aria-hidden="true">-</a>
      </div>
      <div 
        class="toggle"
        @click.stop="$emit('toggle', 1)"
      >
        <a aria-hidden="true"> 0 </a>
      </div>
      <div 
        class="toggle"
        @click.stop="$emit('toggle', value + 0.1 )"
      >
        <a aria-hidden="true">+</a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Switch',
  props: [
    'id',
    'label',
    'value',
    'icons',
  ],
  emits: [
    'toggle'
  ],
  computed: {
    type() { return typeof this.value },
    icon() { return require(`@/assets/icons/${this.icons[this.value]}.js`).default },
  },
  methods: {
    toggle() {
      if (this.type == 'boolean') {
        this.$emit('toggle', !this.value)
      } else if (this.value >= 0.5 && this.value <= 1.5 ) {
        this.$emit('toggle', this.value + 0.1)
      } else if (this.value > 1.5 ) {
        this.$emit('toggle', 1)
      }
    }
  }
}
</script>

<style scoped>
.switch {
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.switch label {
  /* text-align: right; */
  /* margin-right: 0.2em; */
  padding: 0.1em 0.3em;
  border-radius: 0.1em;
  cursor: pointer;
  transition: all var(--fast) ease;
}

.switch .toggles {
  flex-grow: 0;
  flex-shrink: 1;
  /* min-width: 4em; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5em;
}

.switch .toggles .toggle {
  display: flex;
  align-items: center;
  justify-content: center;
}
.switch .toggles .toggle a {
  /* min-width: 3em; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.switch .toggles .toggle a svg,
.switch .toggles .toggle a img {
  padding: 0.2em;
  width: 1.3em;
  height: 100%;
}
.switch .toggles .toggle a svg path {
  fill: var(--dark2)
  /* stroke: var(--light2); */
}
.switch.active .toggles .toggle a,
.switch:hover .toggles .toggle a
/* .switch:focus .toggles .toggle a, */
/* .switch:focus-within .toggles .toggle a  */
{
  background: var(--dark2);
  color: var(--light2);
}
.switch.active .toggles .toggle a svg path,
.switch:hover .toggles .toggle a svg path
/* .switch:focus .toggles .toggle a svg path, */
/* .switch:focus-within .toggles .toggle a svg path  */
{
  fill: var(--light2);
}
.switch .toggles .toggle a:hover,
/* .switch:focus .toggles .toggle a, */
/* .switch:focus-within .toggles .toggle a, */
.switch:hover label,
.switch:hover a,
.switch.active label
/* .switch:focus label, */
/* .switch:focus-within label  */
 {
  background: var(--back);
  color: var(--light2);
}
</style>
